<template>
  <div
    class="preview-alert-card"
    :class="`preview-alert-card-${color}`"
  >
    <div class="preview-alert-card-header">
      <v-icon
        :icon="icon"
        :size="20"
        class="preview-alert-card-icon"
      />
      <span class="preview-alert-card-title text-h2">{{ title }}</span>
    </div>
    <p class="preview-alert-card-body text-body-1 text-textDark mb-0">
      <slot />
      <template v-if="learnMoreHref">
        <a
          :href="learnMoreHref"
          class="preview-alert-card-learn-more ml-1"
          target="_blank"
          rel="noopener noreferrer"
          @click.stop="$emit('learn-more-click')"
        >Learn more here</a>.
      </template>
    </p>
    <div
      v-if="$slots.footer"
      class="preview-alert-card-footer"
    >
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
export const PREVIEW_ALERT_CARD_COLORS = [
  'indigo',
  'blue',
  'green',
  'navy',
  'orange',
  'pink',
  'purple',
  'red',
  'teal',
  'yellow',
  'grey',
];
</script>

<script setup>
defineEmits(['learn-more-click']);

defineProps({
  color: {
    type: String,
    default: 'yellow',
    validator: (value) => PREVIEW_ALERT_CARD_COLORS.includes(value),
  },
  icon: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  learnMoreHref: {
    type: String,
    default: '',
  },
});
</script>

<style scoped lang="less">
.preview-alert-card {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid transparent;
  width: 100%;
}

.preview-alert-card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
}

.preview-alert-card-body {
  width: 100%;
}

.preview-alert-card-learn-more {
  color: @text-brand;
  text-decoration: underline;
  font-size: 14px;
  font-weight: 500;
}

.preview-alert-card-footer {
  width: 100%;
}

.preview-alert-card-indigo {
  background-color: @indigo-100;
  border-color: @indigo-700;

  .preview-alert-card-title,
  .preview-alert-card-icon {
    color: @indigo-700;
  }
}

.preview-alert-card-blue {
  background-color: @blue-100;
  border-color: @blue-700;

  .preview-alert-card-title,
  .preview-alert-card-icon {
    color: @blue-700;
  }
}

.preview-alert-card-green {
  background-color: @green-100;
  border-color: @green-700;

  .preview-alert-card-title,
  .preview-alert-card-icon {
    color: @green-700;
  }
}

.preview-alert-card-navy {
  background-color: @navy-100;
  border-color: @navy-700;

  .preview-alert-card-title,
  .preview-alert-card-icon {
    color: @navy-700;
  }
}

.preview-alert-card-orange {
  background-color: @orange-100;
  border-color: @orange-700;

  .preview-alert-card-title,
  .preview-alert-card-icon {
    color: @orange-700;
  }
}

.preview-alert-card-pink {
  background-color: @pink-100;
  border-color: @pink-500;

  .preview-alert-card-title,
  .preview-alert-card-icon {
    color: @pink-500;
  }
}

.preview-alert-card-purple {
  background-color: @purple-100;
  border-color: @purple-500;

  .preview-alert-card-title,
  .preview-alert-card-icon {
    color: @purple-500;
  }
}

.preview-alert-card-red {
  background-color: @red-100;
  border-color: @red-700;

  .preview-alert-card-title,
  .preview-alert-card-icon {
    color: @red-700;
  }
}

.preview-alert-card-teal {
  background-color: @teal-100;
  border-color: @teal-700;

  .preview-alert-card-title,
  .preview-alert-card-icon {
    color: @teal-700;
  }
}

.preview-alert-card-yellow {
  background-color: @yellow-100;
  border-color: @yellow-700;

  .preview-alert-card-title,
  .preview-alert-card-icon {
    color: @yellow-700;
  }
}

.preview-alert-card-grey {
  background-color: @grey-100;
  border-color: @grey-600;

  .preview-alert-card-title,
  .preview-alert-card-icon {
    color: @grey-700;
  }
}
</style>
